// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"10d27cf3","453":"4c9c27b5","455":"d66ab011","977":"5acd1bad"}[chunkId] + ".chunk.js";
};